  let all_content = document.querySelectorAll('.accord_content');
  let header = document.querySelectorAll('.accord_header');
  header.forEach(function(item){
    item.addEventListener('click', function(){
      
        var content = item.nextElementSibling;
    if(content.style.maxHeight){
    content.style.maxHeight = null;
    item.querySelector(".collapsible-trigger__icon svg").style.transform = "rotate(0deg)"

    }
      else{
         all_content.forEach(function(newItem){
           newItem.style.maxHeight = null;
           
         })
          header.forEach(function(newitem){
          newitem.querySelector("svg").style.transform = "rotate(0deg)";
          })
       content.style.maxHeight = content.scrollHeight + "px";
    item.querySelector(".collapsible-trigger__icon svg").style.transform = "rotate(180deg)"
       
    setTimeout(function(){
      console.log("scroll")
      item.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});}, 200);
       

      }
    })
  })
  
  document.querySelectorAll('.open_at_start').forEach(function(open){
 var header = open.firstElementChild;
  var content = open.lastElementChild;
    header.querySelector("svg").style.transform = "rotate(180deg)";
    content.style.maxHeight = content.scrollHeight + "px";
  })
  
  
if (document.querySelectorAll('.swiper--marquee').length > 0) {
    let SwiperMarquee = new Swiper('.swiper--marquee', {
      spaceBetween: 0,
      centeredSlides: true,
      speed: 6000,
                  slidesPerView: "auto",
      autoplay: {
        delay: 1,
      },
      loop: true,
      allowTouchMove: false,
      disableOnInteraction: true,
      breakpoints: {
        640: {
          slidesPerView: "auto",
          spaceBetween: 0,
        },
        768: {
          slidesPerView: "auto",
          spaceBetween: 0,
        },
        1024: {
          slidesPerView: "auto",
          spaceBetween: 0,
        },
      },
  });
}
  